import React, { useState, useEffect } from "react";
import { Table, Icon, Input, Button } from "semantic-ui-react";
import { Tooltip } from "react-tooltip";

export function TableAlumnosBajas(props) {
  const { alumnos, updateAlumno, asignarFechas, fechaBajaDefiniva, datosAlumno } = props;
  const itemsPerPage = 8;
  const [currentPage, setCurrentPage] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [realTimeSearch, setRealTimeSearch] = useState("");
  const [alumnoSearch, setAlumnoSearch] = useState("");

  useEffect(() => {
    setSearchText(searchText.toLowerCase());
    setAlumnoSearch(alumnoSearch.toLowerCase());
  }, [searchText, alumnoSearch]);

  const handleRealTimeSearchChange = (value) => {
    setRealTimeSearch(value);
    setCurrentPage(1);
  };
  /*
  const handleAlumnoSearchChange = (value) => {
    setAlumnoSearch(value);
    setCurrentPage(1);
  }; */

  const filteredAlumnos = () => {
    return alumnos.filter(
      (alumno) =>
        alumno.nombre.toLowerCase().includes(realTimeSearch) &&
        alumno.apellido_paterno.toLowerCase().includes(alumnoSearch)
    );
  };

  useEffect(() => {
    const lastPage = Math.ceil(filteredAlumnos().length / itemsPerPage);
    if (currentPage > lastPage) {
      setCurrentPage(lastPage);
    }
    // eslint-disable-next-line
  }, [alumnos, currentPage, searchText, alumnoSearch]);

  const paginatedAlumnos = filteredAlumnos().slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div>
      <div>
        <Icon name="search" className="bot" />
        <Input
          placeholder="Buscar por nombre"
          value={realTimeSearch}
          onChange={(e) => handleRealTimeSearchChange(e.target.value)}
          style={{ marginTop: "12px" }}
        />
      </div>
      <Table className="table-users-admin">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>CURP</Table.HeaderCell>
            <Table.HeaderCell>MATRICULA</Table.HeaderCell>
            <Table.HeaderCell>APELLIDO PATERNO</Table.HeaderCell>
            <Table.HeaderCell>APELLIDO MATERNO</Table.HeaderCell>
            <Table.HeaderCell>NOMBRE</Table.HeaderCell>
            <Table.HeaderCell>SEMESTRE</Table.HeaderCell>
            <Table.HeaderCell>FECHA T 1 </Table.HeaderCell>
            <Table.HeaderCell>FECHA T 2</Table.HeaderCell>
            {alumnos.some(alumno => alumno.estado_alumno === "Baja definitiva") && (
              <Table.HeaderCell>FECHA BAJA DEFINITIVA</Table.HeaderCell>
            )}
            <Table.HeaderCell>ACCIONES</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {paginatedAlumnos
            .sort((a, b) =>
              a.apellido_paterno.localeCompare(b.apellido_paterno)
            )
            .map((alumnoo, index) => (
              <Table.Row key={index}>
                <Table.Cell>{alumnoo.curp}</Table.Cell>
                <Table.Cell>{alumnoo.matricula}</Table.Cell>
                <Table.Cell>{alumnoo.apellido_paterno}</Table.Cell>
                <Table.Cell>{alumnoo.apellido_materno}</Table.Cell>
                <Table.Cell>{alumnoo.nombre}</Table.Cell>
                <Table.Cell>{alumnoo.semestre}</Table.Cell>
                <Table.Cell>{alumnoo.fecha_baja_temporal_1}</Table.Cell>
                <Table.Cell>{alumnoo.fecha_baja_temporal_2}</Table.Cell>
                {alumnoo.estado_alumno === "Baja definitiva" && (
                  <Table.Cell>{alumnoo.fecha_baja_definitiva}</Table.Cell>
                )}
                <Actions
                  alumno={alumnoo}
                  updateAlumno={updateAlumno}
                  asignarFechas={asignarFechas}
                  fechaBajaDefiniva={fechaBajaDefiniva}
                  datosAlumno={datosAlumno}
                />
              </Table.Row>
            ))}
        </Table.Body>
      </Table>
      <div style={{ textAlign: "center", marginTop: "10px" }}>
        <Button.Group>
          {Array.from({
            length: Math.ceil(filteredAlumnos().length / itemsPerPage),
          }).map((_, index) => {
            const pageNumber = index + 1;
            const maxVisibleButtons = 4;
            const startPage = Math.max(
              1,
              currentPage - Math.floor(maxVisibleButtons / 2)
            );
            const endPage = Math.min(
              startPage + maxVisibleButtons - 1,
              Math.ceil(filteredAlumnos().length / itemsPerPage)
            );
            const showStartEllipsis = startPage > 1;
            const showEndEllipsis =
              endPage < Math.ceil(filteredAlumnos().length / itemsPerPage);

            // para evitar renderizar el botón si solo hay una página
            if (Math.ceil(filteredAlumnos().length / itemsPerPage) === 1) {
              return null;
            }
            if (pageNumber >= startPage && pageNumber <= endPage) {
              return (
                <Button
                  key={pageNumber}
                  icon
                  active={currentPage === pageNumber}
                  onClick={() => handlePageChange(pageNumber)}
                >
                  {pageNumber}
                </Button>
              );
            } else if (showStartEllipsis && pageNumber === 1) {
              return (
                <Button key="startEllipsis" icon className="bordebotn">
                  {"..."}
                </Button>
              );
            } else if (
              showEndEllipsis &&
              pageNumber === Math.ceil(filteredAlumnos().length / itemsPerPage)
            ) {
              return (
                <Button key="endEllipsis" icon className="bordebotn">
                  {"..."}
                </Button>
              );
            }
            return null;
          })}
        </Button.Group>
      </div>
    </div>
  );
}

function Actions(props) {
  const { alumno, updateAlumno, asignarFechas, fechaBajaDefiniva, datosAlumno } = props;
  return (
    <Table.Cell textAlign="center">
      <div className="action-buttons">
        {alumno.estado_alumno === "Baja temporal" && (
          <Button
            data-tooltip-id="my-tooltip"
            data-tooltip-content="Actualizar datos alumno"
            icon
            className="yellow"
            onClick={() => {
              updateAlumno(alumno);
            }}
          >
            <Icon name="pencil" style={{ color: "white" }}></Icon>
          </Button>
        )}
        {alumno.estado_alumno === "Baja temporal" && (
          <Button
            data-tooltip-id="my-tooltip"
            data-tooltip-content="Asignar fechas de bajas temporales"
            icon
            negative
            onClick={() => {
              asignarFechas(alumno);
            }}
            className="botonEnviar"
          >
            <Icon name="pencil square" style={{ color: "white" }}></Icon>
          </Button>
        )}

        {alumno.estado_alumno === "Baja definitiva" && (
          <Button
            data-tooltip-id="my-tooltip"
            data-tooltip-content="Asignar fecha baja definitiva "
            icon
            negative
            onClick={() => {
              fechaBajaDefiniva(alumno);
            }}
            className="botonEnviar"
          >
            <Icon name="pencil square" style={{ color: "white" }}></Icon>
          </Button>
        )}


          <Button
            data-tooltip-id="my-tooltip"
            data-tooltip-content="Ver datos"
            icon
            onClick={() => {
              datosAlumno(alumno);
            }}
            className="ui primary button"
          >
            <Icon name="eye" style={{ color: "white" }}></Icon>
          </Button>

        <Tooltip id="my-tooltip" />
      </div>
    </Table.Cell>
  );
}
